<template>
  <div class="vx-row flex m-0 justify-center">
    <div class="vx-col lg:w-4/5 md:w-2/3">
      <div class="mt-4 text-right">
        <vs-button @click="$router.go(-1)">Back</vs-button>
      </div>
      <vx-card class="mt-base">
          <div>
            <h2>ID Post: {{id}}</h2>
              <!-- POST HEADER -->
              <div class="post-header flex justify-between mb-4">
                  <div class="flex items-center">
                      <div>
                          <vs-avatar class="m-0" :src="userLatestPhotos[0]" size="45px"></vs-avatar>
                      </div>
                      <div class="ml-4">
                          <h6>{{ post.author }}</h6>
                          <small>{{ post.time }} at {{ post.time }}</small>
                      </div>
                  </div>
                  <div class="flex">
                      <feather-icon class="ml-4" icon="HeartIcon" :svgClasses="{'text-danger fill-current stroke-current': post.isLiked}"></feather-icon>
                  </div>
              </div>

              <!-- POST CONTENT -->
              <div class="post-content">
                  <p>{{ post.text }}</p>
              </div>
              <div class="post-media-container mb-6 mt-4">
                  <ul class="flex post-media-list">
                    <li class="post-media m-1 w-auto mx-auto" v-for="(media, mediaIdex) in post.media.slice(0, 2)" :key="mediaIdex">
                        <img class="responsive rounded lg:max-w-md" :src="media.img" alt="user-upload">                    </li>
                  </ul>
                  <span class="flex justify-end" v-if="post.media.length > 2">
                      <a class="inline-flex items-center text-sm" href=""><span>View All</span> <feather-icon :icon="$vs.rtl ? 'ChevronsLeftIcon' : 'ChevronsRightIcon'" svgClasses="h-4 w-4"></feather-icon></a>
                  </span>
              </div>

              <!-- POST ACTION DATA -->
              <div>
                  <div class="flex justify-between">
                      <div class="flex items-center">
                          <div class="flex items-center"><feather-icon class="mr-2" icon="HeartIcon" svgClasses="h-5 w-5"></feather-icon> <span>{{ post.likes }}</span></div>
                          <ul class="users-liked user-list ml-3 sm:ml-6">
                              <li v-for="(user, userIndex) in post.usersLiked" :key="userIndex">
                                  <vx-tooltip :text="user.name" position="bottom">
                                      <vs-avatar :src="user.img" size="30px" class="border-2 border-white border-solid -m-1"></vs-avatar>
                                  </vx-tooltip>
                              </li>
                          </ul>
                          <small class="ml-2">+{{ post.likes - 5 }} more</small>
                      </div>
                      <div class="flex items-center"><feather-icon class="mr-2" icon="MessageSquareIcon" svgClasses="h-5 w-5"></feather-icon> <span>{{ post.comments }}</span></div>
                  </div>
                  <div class="comments-container mt-4">
                      <ul class="user-comments-list">
                          <li v-for="(commentedUser, commentIndex) in post.usersCommented.slice(0, 2)" :key="commentIndex" class="commented-user flex items-center mb-4">
                              <div class="mr-3"><vs-avatar class="m-0" :src="commentedUser.img" size="30px" /></div>
                              <div class="leading-tight">
                                  <p class="font-medium">{{ commentedUser.author }}</p>
                                  <span class="text-xs">{{ commentedUser.comment }}</span>
                              </div>
                              <div class="ml-auto">
                                  <div class="flex">
                                      <feather-icon icon="HeartIcon" svgClasses="h-4 w-4" class="mr-2 cursor-pointer"></feather-icon>
                                      <feather-icon icon="MessageSquareIcon" svgClasses="h-4 w-4" class="cursor-pointer"></feather-icon>
                                  </div>
                              </div>
                          </li>
                      </ul>
                      <span class="flex justify-end" v-if="post.usersCommented.length > 2">
                          <a class="inline-flex items-center text-sm" href=""><span>View All</span> <feather-icon :icon="$vs.rtl ? 'ChevronsLeftIcon' : 'ChevronsRightIcon'" svgClasses="h-4 w-4"></feather-icon></a>
                      </span>
                  </div>
                  <div class="post-comment">
                      <vs-textarea label="Add Comment" class="mb-2" v-model="post.commentbox" />
                      <vs-button size="small">Post Comment</vs-button>
                  </div>
              </div>
          </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      id : this.$route.params.id,
      userLatestPhotos: [
        require('../../../../../../assets/images/profile/user-uploads/user-01.jpg'),
        require('../../../../../../assets/images/profile/user-uploads/user-02.jpg'),
        require('../../../../../../assets/images/profile/user-uploads/user-04.jpg'),
        require('../../../../../../assets/images/profile/user-uploads/user-03.jpg'),
        require('../../../../../../assets/images/profile/user-uploads/user-05.jpg'),
        require('../../../../../../assets/images/profile/user-uploads/user-06.jpg'),
        require('../../../../../../assets/images/profile/user-uploads/user-07.jpg'),
        require('../../../../../../assets/images/profile/user-uploads/user-08.jpg'),
        require('../../../../../../assets/images/profile/user-uploads/user-09.jpg')
      ],
      post: {
        author     : 'Leeanna Alvord',
        time       : 'Mon Dec 12 2018 07:46:05 GMT+0000 (GMT)',
        isLiked    : true,
        text       : 'I love jujubes wafer pie ice cream tiramisu. Chocolate I love pastry pastry sesame snaps wafer. Pastry topping biscuit lollipop topping I love lemon drops sweet roll bonbon. Brownie donut icing.',
        media      : [{ img: require('../../../../../../assets/images/profile/post-media/2.jpg') }],
        likes      : 145,
        comments   : 77,
        usersLiked : [
          { name: 'Trina Lynes',       img: require('../../../../../../assets/images/portrait/small/avatar-s-1.jpg') },
          { name: 'Lilian Nenez',      img: require('../../../../../../assets/images/portrait/small/avatar-s-2.jpg') },
          { name: 'Alberto Glotzbach', img: require('../../../../../../assets/images/portrait/small/avatar-s-3.jpg') },
          { name: 'George Nordick',    img: require('../../../../../../assets/images/portrait/small/avatar-s-4.jpg') },
          { name: 'Vennie Mostowy',    img: require('../../../../../../assets/images/portrait/small/avatar-s-5.jpg') }
        ],
        commentbox : '',
        usersCommented: [
          {
            comment : 'orthoplumbate morningtide naphthaline exarteritis',
            author  : 'Kitty Allanson',
            img     : require('../../../../../../assets/images/portrait/small/avatar-s-6.jpg'),
            time    : 'Mon Dec 10 2018 08:56:05 GMT+0000 (GMT)'
          },
          {
            comment : 'blockiness pandemy metaxylene speckle coppy',
            author  : 'Jeanie Bulgrin',
            img     : require('../../../../../../assets/images/portrait/small/avatar-s-8.jpg'),
            time    : 'Mon Dec 10 2018 08:55:00 GMT+0000 (GMT)'
          }
        ]
      }
    }
  },
}
</script>
